<template>
  <div>
    <h2>施設設定 編集</h2>

    <v-progress-linear v-if="isLoading" indeterminate />

    <v-form v-model="isFormValid">
      <v-container class="mt-4">
        <v-row>
          <v-col>
            <h3>施設情報</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>施設名*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.nurseryName"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>部門コード</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.departmentCode"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>都道府県</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.prefecture"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>市区町村番地</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.address"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>建物・部屋番号</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.building"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>電話番号</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.phoneNumber"
              :rules="[isTel]"
              label="ハイフンあり"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>FAX</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.faxNumber"
              :rules="[isTel]"
              label="ハイフンあり"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>施設メールアドレス</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.representativeEmail"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>姓*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.lastName"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>名*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.firstName"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>姓（カナ）*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.lastNameKana"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>名（カナ）*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.firstNameKana"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>性別*</h5>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="inputValue.gender"
              :items="genderItems"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>生年月日*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.dateOfBirth"
              :rules="[required]"
              variant="outlined"
              density="compact"
              type="date"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>メールアドレス*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.email"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row>
        <v-col cols="6">
          <h5>スタッフ区分*</h5>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="inputValue.category"
            :items="categoryItems"
            :rules="[required]"
            variant="outlined"
            density="compact"
          ></v-select>
        </v-col>
      </v-row> -->

        <v-row>
          <v-col cols="6">
            <h5>入社日*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.joinDate"
              :rules="[required]"
              variant="outlined"
              density="compact"
              type="date"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>配属日*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.assignDate"
              :rules="[required]"
              variant="outlined"
              density="compact"
              type="date"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <div class="d-flex justify-center my-6">
      <v-btn
        v-if="this.nurseryId"
        @click="updateNursery"
        :disabled="isLoading || !isFormValid"
        color="primary"
        depressed
        large
        >保存</v-btn
      >
      <v-btn
        v-else
        @click="createNursery"
        :disabled="isLoading || !isFormValid"
        color="primary"
        depressed
        large
        >作成</v-btn
      >
    </div>

    <v-divider />

    <v-form v-model="isBankAccountFormValid">
      <v-container v-if="nurseryId" class="pt-8">
        <v-row>
          <v-col>
            <h3>銀行口座情報</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>金融機関名*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.beneficiaryBank"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>支店名*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.branchName"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>口座種別*</h5>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="inputValue.accountCategory"
              :rules="[required]"
              :items="accountCategoryItems"
              variant="outlined"
              density="compact"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>口座番号*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.accountNumber"
              :rules="[required, isAccountNumber]"
              variant="outlined"
              density="compact"
              label="6桁/7桁"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>口座名義*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.accountHolder"
              :rules="[required]"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h5>引落日*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.withdrawalDate"
              :rules="[required, isWithdrawalDate]"
              suffix="日"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <div class="py-6 d-flex justify-center align-center">
      <v-btn
        @click="updateBankAccount"
        :disabled="isLoading || !isBankAccountFormValid"
        color="primary"
        depressed
        large
      >
        保存
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ApiNursery, { PutNurseryRequest } from "@/api/ApiNursery";
import { nurseryModule } from "@/store/dataModule/nurseryModule";
import ValidationMixin from "@/mixins/ValidationMixin";
import LocalDataService from "@/service/LocalDataService";

export default defineComponent({
  mixins: [ValidationMixin],

  async mounted() {
    if (this.nurseryId) {
      await this.getNursery();
    }
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
      isBankAccountFormValid: false,
      inputValue: {} as PutNurseryRequest,
      accountCategoryItems: [
        { title: "普通", value: "normal" },
        { title: "総合", value: "general" },
        { title: "貯蓄", value: "saving" },
        { title: "当座", value: "current" },
      ],
      genderItems: [
        { title: "男性", value: "male" },
        { title: "女性", value: "female" },
      ],
      categoryItems: [
        { title: "一般", value: "general" },
        { title: "ヘルプ", value: "help" },
      ],
    };
  },

  computed: {
    nurseryId: function () {
      return this.$route.params.id;
    },
  },

  methods: {
    async getNursery() {
      this.isLoading = true;
      if (this.nurseryId) {
        const nurseryId = Array.isArray(this.nurseryId)
          ? this.nurseryId[0]
          : this.nurseryId;

        const response = await nurseryModule.getNursery({
          nurseryId,
        });

        if (response) {
          this.inputValue = response as any;
        }
      }
      this.isLoading = false;
    },
    async updateNursery() {
      this.isLoading = true;
      if (this.inputValue) {
        this.inputValue.category = "general";

        await nurseryModule
          .updateNursery({
            ...this.inputValue,
          })
          .catch((e) => console.warn(e));
        this.$router.push({ path: "/school" });
      }
      this.isLoading = false;
    },
    async createNursery() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId && this.inputValue) {
        this.inputValue.category = "general";

        await nurseryModule
          .createNursery({
            companyId,
            ...this.inputValue,
          })
          .catch(() => (this.isLoading = false));
        this.$router.push({ path: "/school" });
      }
      this.isLoading = false;
    },
    async updateBankAccount() {
      this.isLoading = true;
      if (this.inputValue.nurseryId) {
        await ApiNursery.updateBankAccount({
          ...this.inputValue,
        }).catch(() => (this.isLoading = false));
        this.$router.push({ path: "/school" });
      }
      this.isLoading = false;
    },
  },
});
</script>
